module.exports = __webpack_public_path__ + "media/assets/images/blog/POST-BLOG-PLOT-20-08-9d5bf20928b7a11cfeb45fbb7adcd704.png";